module.exports = __webpack_public_path__ + "assets/person_black.c07a8f30.svg";